import NoLabResultImg from "../assets/labresultempty.png";
import React from "react";

export default function NoMedicalResult() {
  return (
    <div className="text-center py-3 px-16">
      <img
        src={NoLabResultImg}
        alt="calendar"
        className="block m-auto w-28 h-28 my-4"
      />
      <p className="font-bold text-lg">No medical test results available</p>
      <p className="text-gray-500">
        Currently there are no medical test results available for viewing. As
        soon as your medical tests are completed, you'll find them here
      </p>
    </div>
  );
}
